import Vue from 'vue';
import Vuex from 'vuex';
import { getRequest, postRequest } from '@/common/libs/request';
import Cookies from 'js-cookie';
Vue.use(Vuex);

// 用来存储数据
const state = {
  userInfo: {},
  currentProject: {
    env: {
      status: 0,
    },
  },
  projectList: [],
  teamIsShow: false,
  connectError: false,
  COSBrowserCopyData: '',
  menuSelectIndex: 0,
  createMasterNode: 0,
  uploadProgressList: [],
};
// 响应组件中的事件
const actions = {
  // 获取用户信息
  async getUserInfo({ commit }) {
    try {
      const res = await getRequest('/api/eda/common/eda/getUserInfo');
      // console.log(res, 'getUserInfo');
      // sessionStorage.setItem('loginType', res.way);
      sessionStorage.setItem('isAdmin', res.isAdmin);
      sessionStorage.setItem('userId', res.userId);
      commit('setUserInfo', res);
    } catch (e) {
      // console.log(11, e);
    }
  },
  // 获取项目列表
  async getProjectList({ commit }) {
    try {
      const res = await getRequest('/api/eda/common/eda/getProjectList');
      commit('setProjectList', res);
    } catch (e) {
      // console.log(11, e);
    }
  },

  // 获取项目列表  选择最新的项目
  async getProjectListSelectedNew({ commit }) {
    try {
      const res = await getRequest('/api/eda/common/eda/getProjectList');
      await commit('setProjectList', res);
      await commit('setCurrentProject', res.list[0]);
    } catch (e) {
      // console.log(11, e);
    }
  },
  // 获取项目信息
  async getProjectInfo(_, playload) {
    try {
      if (playload) {
        const data = await postRequest('/api/eda/common/project/getProjectInfo');
        return data;
      }
    } catch (e) {
      // console.log(11, e);
    }

    return true;
  },
};

// 操作数据
const mutations = {
  // 创建团队 显示
  setTeamIsShow(state, data) {
    state.teamIsShow = data;
  },
  // 设置用户信息
  setUserInfo(state, data) {
    state.userInfo = data;
  },
  // 设置windows桌面连接失败弹窗遮罩
  setConnectError(state, data) {
    state.connectError = data;
  },
  setCOSBrowserCopyData(state, data) {
    state.COSBrowserCopyData = data;
  },

  // 新建团队后的菜单选择
  setMenuSelectIndex(state, data) {
    state.menuSelectIndex = data;
  },
  // 新建管理节点
  setCreateMasterNode(state, data) {
    state.createMasterNode = data;
  },

  // 获取上传进度列表
  setUploadProgressList(state, data) {
    console.log(data, '获取上传进度列表获取上传进度列表获取上传进度列表');
    state.uploadProgressList = data;
  },

  // 设置项目列表
  async setProjectList(state, data) {
    state.projectList = data.list || [];
    if (data.total > 0) {
      const currentProjectLength = 0;
      const currentProjectStr = window.sessionStorage.getItem('currentProject');
      if (currentProjectStr) {
        const currentProject = JSON.parse(currentProjectStr);

        // 如果已经存在当前项目， 直接返回
        if (currentProject && currentProject.id && currentProject !== 'undefined') {
          const filter = data.list.filter(item => item.id === currentProject.id);
          if (filter.length > 0) {
            state.currentProject = filter[0] || {};
            Cookies.set('CurrentProjectId', currentProject.id, { expires: 7 });
            window.sessionStorage.setItem('currentProject', JSON.stringify(filter[0]));
          } else {
            state.currentProject = data.list[currentProjectLength];
            Cookies.set('CurrentProjectId', data.list[currentProjectLength].id, { expires: 7 });
            window.sessionStorage.setItem('currentProject', JSON.stringify(data.list[currentProjectLength]));
          }
        } else {
          state.currentProject = data.list[currentProjectLength];
          Cookies.set('CurrentProjectId', data.list[currentProjectLength].id, { expires: 7 });
          window.sessionStorage.setItem('currentProject', JSON.stringify(data.list[currentProjectLength]));
        }
      } else {
        state.currentProject = data.list[currentProjectLength];
        Cookies.set('CurrentProjectId', data.list[currentProjectLength].id, { expires: 7 });
        window.sessionStorage.setItem('currentProject', JSON.stringify(data.list[currentProjectLength]));
      }
    }
  },
  // 设置当前项目
  setCurrentProject(state, data) {
    state.currentProject = data;
    Cookies.set('CurrentProjectId', data.id, { expires: 7 });
    window.sessionStorage.setItem('currentProject', JSON.stringify(data));
  },
  clearCurrentProject() {
    window.sessionStorage.removeItem('currentProject');
  },
};
// 用来将state数据进行加工
const getters = {
  getCurrentProject(state) {
    return () => {
      const currentProjectStr = window.sessionStorage.getItem('currentProject');
      if (currentProjectStr) {
        try {
          const currentProject = JSON.parse(currentProjectStr);
          const filter = state.projectList.filter(item => item.id === currentProject.id);
          if (filter.length === 0) {
            return state.projectList.length > 0 ? state.projectList[state.projectList.length - 1] : currentProject;
          }
          return filter[0] || {};
        } catch (e) {
          return {};
        }
      } else {
        return {};
      }
    };
  },
};

// 新建并暴露store
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
